import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardContent,
  Button,
  Container,
  Grid,
  Typography,
  CardActions,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { IDEA_FORM } from "navigation/CONSTANTS";
import Header from "components/Header";
import  TranslationProvider  from "providers/TranslationProvider";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";
const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
    borderRadius: 8,
  },
  root: {
    minWidth: "80%",
  },
}));

function IdeaFormSuccess() {
  const classes = useStyles();
  const history = useHistory();

  const onSubmit = () => {
    history.push(IDEA_FORM);
  };
  const {version}=useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }
  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);
useEffect(() => {
    document.title = 'GOC Innovation Survey';
  });
  const { t, i18n } = useTranslation();
  return (
    <>
      <Container maxWidth="sm">
      <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
            <TranslationProvider />                         
                <Header />                                                                      
            </Grid>
         </Grid>          
        <Grid container direction="column" alignItems="stretch" spacing={2}>
          <Grid item>
            <Card className={classes.header}>
              <CardContent>
              <Typography variant="h6" gutterBottom color="textPrimary">
                   {t("other.lblSuccessSubmit")}  
                </Typography>
                <Typography variant="body" gutterBottom color="textPrimary">
                  <b> {t("other.lblThankYou")}  </b> {t("other.lblThanksMessage")} 
                </Typography>
                <Typography size="medium" color="primary">
                  <u><a href="https://sites.google.com/ironmountain.com/gos/our-resources/global-continuous-improvement/global-operations-council-mission" target="_blank">https://sites.google.com/ironmountain.com/gos/our-resources/global-continuous-improvement/global-operations-council-mission.</a></u>
                </Typography>
                <Typography>
                {t("other.lblMoreIdeas")}  
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="medium" color="primary" onClick={onSubmit}>
                {t("other.lblSubmitAnotherForm")} 
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default IdeaFormSuccess;
